import { useQuery } from '@tanstack/react-query';

import type { SubscriptionBillingSummary } from '~/interfaces/subscriptions';

interface Props {
  enabled: boolean;
  subscriberId: string;
}

interface ReturnProps {
  isLoading: boolean;
  billingSummary?: Record<string, SubscriptionBillingSummary>;
  refetch: () => void;
}

const useStaticTiersBillingSummary = ({ enabled, subscriberId }: Props): ReturnProps => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['tier-billing-summary', subscriberId],
    queryFn: async (): Promise<Record<string, SubscriptionBillingSummary>> => {
      const response = await fetch('/tier_billing_summary');
      if (!response.ok) {
        throw new Error('Failed to load tier billing summary');
      }
      return response.json();
    },
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    billingSummary: data,
    refetch,
  };
};

export default useStaticTiersBillingSummary;
